import React from 'react';
import { Link } from 'react-router-dom';
import useTools from '../../../Hooks/useTools';
import Tool from './Tool';
import './Tools.css'

const Tools = () => {
    const [tools] = useTools();
    const recentTools = [...tools].reverse();
    const minTools = recentTools.slice(0, 6);
    return (

        <div className='bg-slate-100 md:pt-52 py-10 md:mt-[-122px] md:relative md:z-0'>
            <h1 className='text-center md:text-4xl text-3xl font-semibold text-gray-900 my-5'>Lenses We have</h1>
            <p className='text-center text-2xl text-gray-700 mb-20'>Tools that you need most for make your life easy</p>
            <div className="hero">
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5'>
                    {
                        minTools.map(tool => <Tool
                            key={tool._id}
                            tool={tool}
                        >
                        </Tool>)
                    }

                </div>
            </div>
            <div className="flex justify-center items-center mt-16 ">
                <Link to='/lens' className='btn btn-primary'>Check Out more</Link>
            </div>
        </div>
    );
};

export default Tools;